import apiHandler from "../core/apiHandler";

/**
 * 🌐 systemOperationModeApi
 * ------------------------------------------------------------
 * Define el cliente base para las peticiones HTTP relacionadas con
 * la configuración del modo de operación del sistema.
 *
 * Controlador backend: `/api/settings/system-operation-mode`
 *
 * Este módulo no contiene lógica de negocio — solo la definición base.
 * Las funciones específicas (getActiveConfig, saveConfig, etc.)
 * se implementan en el servicio correspondiente.
 */
const systemOperationModeApi = apiHandler("settings/system-operation-mode");

export default systemOperationModeApi;
